import * as Immutable from 'immutable';
import {Language} from '../../auth-module/model/language';

import {Label} from './label';
import {Link} from './link';
import {TemplateId} from './template-id';
import {TreeElement} from './treeelement';

export class PathElement {

  constructor(private _id: string, private _label: string, private _isLocal:boolean = false) {
  }

  get id(): string {
    return this._id;
  }

  get label(): string {
    return this._label;
  }

  get isLocal():boolean {
    return this._isLocal;
  }
}

export interface Tree {
  readonly source: 'customer' | 'offline' | TemplateId;
  readonly path: PathElement[];
  readonly localPath: PathElement[];
  readonly root: string;
  readonly labels: Immutable.Map<number, Label>;
  readonly nodes: Immutable.Map<string, TreeElement>;
  readonly links: Immutable.Map<string, Link>;
  readonly backLinks: Immutable.Map<string, Link>;
}

export interface TreeWithLanguages extends Tree {
  readonly languages: Language[];
  readonly translatedNodes: Immutable.Map<number, Immutable.Map<string, TreeElement>>;
  readonly translatedLinks: Immutable.Map<number, Immutable.Map<string, Link>>
}
